import { SupportedLocales } from '@/models/localization.model';
import { IMultiLanguageAddress } from '@/models/place.model';

export enum SettingsFormFields {
  CONTACT_EMAIL = 'contact_email',
  CONTACT_PHONE = 'contact_phone',
  GOOGLE_ANALYTICS = 'google_analytic',
  ADMIN_EMAILS = 'admin_emails',
  ORDER_EMAILS = 'order_emails',
  PRICE_CHANGE_ADMIN_EMAILS = 'price_change_admin_emails',
  ADDRESS = 'address',
  WORKING_HOURS = 'working_hours',
  TWITTER = 'twitter',
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  THREADS = 'threads',
  VIBER = 'viber',
  TELEGRAM = 'telegram',
  TIK_TOK = 'tiktok',
  YOUTUBE = 'youtube',
  LOCALE = 'locale',
  FOP_ID = 'fop_merchant',
  FOP_DESCRIPTION = 'fop_merchant_description',
  TOV_ID = 'tov_merchant',
  TOV_DESCRIPTION = 'tov_merchant_description',
  MIN_ORDER_TOTAL = 'min_order_total',
  FOP_CASH_REGISTER_ID = 'fop_cash_register_id',
  TOV_CASH_REGISTER_ID = 'tov_cash_register_id',
  FOP_CASHIER_NAME = 'fop_cashier_name',
  TOV_CASHIER_NAME = 'tov_cashier_name',
  FOP_FISCAL_DEPARTMENT = 'fop_fiscal_department',
  TOV_FISCAL_DEPARTMENT = 'tov_fiscal_department',
}

export type TSettingsFormValues = {
  [SettingsFormFields.CONTACT_EMAIL]: string;
  [SettingsFormFields.CONTACT_PHONE]: string;
  [SettingsFormFields.ADMIN_EMAILS]: string[];
  [SettingsFormFields.ORDER_EMAILS]: string[];
  [SettingsFormFields.PRICE_CHANGE_ADMIN_EMAILS]: string[];
  [SettingsFormFields.GOOGLE_ANALYTICS]?: string;
  [SettingsFormFields.TWITTER]?: string;
  [SettingsFormFields.FACEBOOK]?: string;
  [SettingsFormFields.INSTAGRAM]?: string;
  [SettingsFormFields.THREADS]?: string;
  [SettingsFormFields.VIBER]?: string;
  [SettingsFormFields.TELEGRAM]?: string;
  [SettingsFormFields.TIK_TOK]?: string;
  [SettingsFormFields.YOUTUBE]?: string;
  [SettingsFormFields.FOP_ID]?: string;
  [SettingsFormFields.TOV_ID]?: string;
  [SettingsFormFields.FOP_DESCRIPTION]?: string;
  [SettingsFormFields.TOV_DESCRIPTION]?: string;
  [SettingsFormFields.MIN_ORDER_TOTAL]: number;
  [SettingsFormFields.FOP_CASH_REGISTER_ID]?: string;
  [SettingsFormFields.TOV_CASH_REGISTER_ID]?: string;
  [SettingsFormFields.FOP_CASHIER_NAME]?: string;
  [SettingsFormFields.TOV_CASHIER_NAME]?: string;
  [SettingsFormFields.FOP_FISCAL_DEPARTMENT]?: string;
  [SettingsFormFields.TOV_FISCAL_DEPARTMENT]?: string;
  [SettingsFormFields.ADDRESS]: IMultiLanguageAddress;
  [SettingsFormFields.LOCALE]: Record<
    SupportedLocales,
    {
      [SettingsFormFields.WORKING_HOURS]: string;
    }
  >;
};
